import { render, staticRenderFns } from "./DataStepTwo.vue?vue&type=template&id=3a6eb1b5&scoped=true&"
import script from "./DataStepTwo.vue?vue&type=script&lang=js&"
export * from "./DataStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./DataStepTwo.vue?vue&type=style&index=0&id=3a6eb1b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6eb1b5",
  null
  
)

export default component.exports